import { defineTool } from '@/shell/tool';

/** Years (Flutter `/years`). */
export default defineTool({
  id: 'years',
  title: 'Years',
  summary: 'The year levels a course and a student are placed in.',
  section: 'learning-backend',
  order: 50,
  icon: 'calendar_today',
  owner: '@Drabu',
  permission: 'years:use',
  routes: () => import('./YearsPage'),
});
